var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    fill: "#f1af1d",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    opacity: 1,
    fill: "#d5a07b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    opacity: 1,
    fill: "#d5a07b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    opacity: 1,
    d: "M503.259+91.161L515.746+91.161C622.302+91.161+708.683+177.542+708.683+284.098L708.683+284.098C708.683+310.614+609.482+301.572+509.502+301.58C410.304+301.589+310.322+310.858+310.322+284.098L310.322+284.098C310.322+177.542+396.703+91.161+503.259+91.161Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M319.063+287.844C319.063+287.844+373.385+255.376+346.537+290.966C333.377+308.409+349.034+372.917+342.166+372.137C335.298+371.356+319.063+322.81+319.063+287.844Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#404040",
    d: "M701.616+285.547C701.616+285.547+644.118+259.108+674.638+291.605C689.597+307.532+680.967+373.349+687.712+371.835C694.456+370.32+705.376+320.31+701.616+285.547Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent9);
export default __webpack_public_path__ + "static/media/Student 9.dbe94787405af65ffa9ff9a16929efac.svg";
export { ForwardRef as ReactComponent };